import { Section } from '@/components/ui/layouts/sections/Section';
import { Icon } from '@mage-ui/components';
import {
  carouselMiniCardsSettings,
  icon,
  link,
  miniCardsBlock,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { InstancesCarousel } from '../InstancesCarousel';

export const MiniCardsBlock = ({ data }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
        intro: data?.fields?.intro,
        meta: data?.fields?.meta_info,
        epi: data?.fields?.epi,
      }}
      className={miniCardsBlock().root}
      footer={
        (data?.cta_text || data?.fields?.cta_text) && (
          <Link
            href={data?.cta_slug || data?.fields?.cta_slug || '#'}
            className={link({ size: 'l' })}
          >
            {data?.fields?.cta_text}
            <Icon name='arrow_long_forward' classNames={icon({ size: 'l' })} />
          </Link>
        )
      }
    >
      <InstancesCarousel
        indicatorThreshold={3}
        settings={carouselMiniCardsSettings()}
        instances={data?.relations?.MiniCardsList}
      />
    </Section>
  );
};
